import type { PlatePlugin } from '@udecode/plate';
import {
  createComboboxPlugin,
  createLinkPlugin,
  createMentionPlugin,
  createParagraphPlugin,
  createPlugins,
} from '@udecode/plate';

import * as config from './config';

export const getPlugins = ({ allowMentions = false }: GetPluginsProps = {}) => {
  const plugins: PlatePlugin[] = [
    createParagraphPlugin(),
    createLinkPlugin(config.linkPlugin),
  ];

  if (allowMentions) {
    plugins.push(createComboboxPlugin());
    plugins.push(createMentionPlugin(config.mentionPlugin));
  }

  return createPlugins(plugins, {
    components: config.components,
  });
};

type GetPluginsProps = {
  allowMentions?: boolean;
};
